export function getParams (state){
    return state.params
}



// WEBPACK FOOTER //
// ./src/modules/contacts-clerks/getters.js